<article class="source-card" [attr.aria-label]="source.name + ' — ' + statusMeta.label">
  <!-- Thumbnail -->
  <div class="source-card__thumbnail">
    @if (source.thumbnail) {
      <img
        [src]="source.thumbnail"
        [alt]="source.name"
        loading="lazy"
        (error)="onThumbnailError($event)"
      />
    }
    <div class="source-card__status-badge" [ngClass]="statusMeta.cssClass">
      {{ statusMeta.label | uppercase }}
    </div>
  </div>

  <!-- Source Info -->
  <div class="source-card__info">
    <div class="source-card__name-col">
      <span class="source-card__name">{{ source.name }}</span>
    </div>

    <div class="source-card__detail-col">
      <span class="source-card__detail-label">Protocol</span>
      <span class="source-card__detail-value">{{ source.protocolLabel }}</span>
    </div>

    <div class="source-card__detail-col">
      <span class="source-card__detail-label">Latency</span>
      <span class="source-card__detail-value">{{ source.totalLatencyMs != null ? source.totalLatencyMs + ' ms' : '—' }}</span>
    </div>

    <div class="source-card__detail-col">
      <span class="source-card__detail-label">Address</span>
      <span class="source-card__detail-value">{{ source.address || '—' }}</span>
    </div>
  </div>

  <!-- Actions -->
  <div class="source-card__actions">
    <button type="button" class="source-card__action-btn source-card__action-btn--edit" aria-label="Edit source">
      <svg width="21" height="21" viewBox="0 0 21 21" fill="currentColor" aria-hidden="true">
        <path d="M12.4042 7.88947L13.1708 8.65614L5.62083 16.2061H4.85417V15.4395L12.4042 7.88947ZM15.4042 2.8728C15.1958 2.8728 14.9792 2.95614 14.8208 3.11447L13.2958 4.63947L16.4208 7.76447L17.9458 6.23947C18.2708 5.91447 18.2708 5.38947 17.9458 5.06447L15.9958 3.11447C15.8292 2.9478 15.6208 2.8728 15.4042 2.8728ZM12.4042 5.53114L3.1875 14.7478V17.8728H6.3125L15.5292 8.65614L12.4042 5.53114Z"/>
      </svg>
    </button>
    <button type="button" class="source-card__action-btn source-card__action-btn--delete" aria-label="Delete source" (click)="onDelete()">
      <svg width="19" height="18" viewBox="0 0 19 18" fill="currentColor" aria-hidden="true">
        <g>
          <path d="M19,2h-2v0h-2V0H4v2H2v0H0V3h2v15h15V3h2V2z M4.9,0.9h9.2V2H4.9V0.9z M16.1,17.1H2.9V3H4v0h11v0h1.1V17.1z"/>
          <rect x="6" y="5" width="1" height="10" />
          <rect x="9" y="5" width="1" height="10" />
          <rect x="12" y="5" width="1" height="10" />
        </g>
      </svg>
    </button>
  </div>
</article>
